import { ArrowRightOutlined, SafetyCertificateOutlined } from '@ant-design/icons';
import { Alert, Button } from 'antd';
import React, { FunctionComponent } from 'react';
import { Redirect, useLocation } from 'react-router-dom';
import { useAuth } from '../../features/auth/AuthContext';
import logo from '../../logo.svg';
import './Login.less';

function safeReturnTo(search: string): string {
  const value = new URLSearchParams(search).get('returnTo');
  return value?.startsWith('/') && !value.startsWith('//') ? value : '/apps';
}

export const Login: FunctionComponent = () => {
  const location = useLocation();
  const auth = useAuth();
  const params = new URLSearchParams(location.search);
  const returnTo = safeReturnTo(location.search);
  const error = params.get('error');

  if (!auth.loading && auth.authenticated) return <Redirect to={returnTo} />;

  const beginLogin = () => {
    window.location.assign(`/auth/qlik/login?returnTo=${encodeURIComponent(returnTo)}`);
  };

  return (
    <div id="click-ci-login">
      <img className="wave" alt="" src={`${process.env.PUBLIC_URL}/img/wave.png`} />
      <div className="container">
        <div className="img bg" aria-hidden="true">
          <div className="login-story">
            <span>CLICK-CI</span>
            <h1>Govern Qlik changes from source to release.</h1>
            <p>Version control, quality evidence, deployment and lineage in one controlled workflow.</p>
          </div>
        </div>
        <div className="login-content">
          <div className="login-form">
            <img alt="Click-CI" src={logo} />
            <h2>Sign in to Click-CI</h2>
            <p className="login-intro">Use your Qlik Cloud identity. GitHub is connected separately after sign-in.</p>
            {error && <Alert showIcon type="error" message="Qlik sign-in could not be completed" description="Try again. If the problem continues, ask the Click-CI administrator to verify the OAuth callback configuration." />}
            <Button block type="primary" size="large" className="oauth-login-btn qlik" icon={<SafetyCertificateOutlined />} onClick={beginLogin}>
              Continue with Qlik Cloud <ArrowRightOutlined />
            </Button>
            <div className="login-trust">
              <SafetyCertificateOutlined />
              <span><strong>Qlik establishes your identity</strong><small>Click-CI stores its own secure session; GitHub is never used as a login method.</small></span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
